import { createContext, useContext, ReactNode } from 'react';
import { Client } from '@connectrpc/connect';
import { SmgService } from '../../generated/smg_service_pb';
import { PartnerService } from '../../generated/partner_service_pb';
import { PublicApiService } from '../../generated/smg_public_api_pb';
import { PlayerBaySessionService } from '../../generated/player_bay_session_pb';
import { SMG_Client, Partner_Client, PublicClient, PlayerBaySession_Client } from '../constants';

export interface ConnectClients {
  smg: Client<typeof SmgService>;
  partner: Client<typeof PartnerService>;
  publicApi: Client<typeof PublicApiService>;
  baySession: Client<typeof PlayerBaySessionService>;
}

const defaultClients: ConnectClients = {
  smg: SMG_Client,
  partner: Partner_Client,
  publicApi: PublicClient,
  baySession: PlayerBaySession_Client,
};

const ConnectClientContext = createContext<ConnectClients>(defaultClients);

interface ConnectClientProviderProps {
  children: ReactNode;
  clients?: ConnectClients;
}

export function ConnectClientProvider({ children, clients = defaultClients }: ConnectClientProviderProps) {
  return (
    <ConnectClientContext.Provider value={clients}>
      {children}
    </ConnectClientContext.Provider>
  );
}

export function useConnectClients(): ConnectClients {
  return useContext(ConnectClientContext);
}
